/**
 * 服务器配置工具
 * 根据环境自动选择服务器地址
 */
const REMOTE_HOST = import.meta.env.VITE_SERVER_HOST || '43.199.229.125';
const WS_PORT = import.meta.env.VITE_WS_PORT || '3002';
const HTTP_PORT = import.meta.env.VITE_HTTP_PORT || '3003';
const USE_SSL = import.meta.env.VITE_USE_SSL === 'true';

export default class ServerConfig {
    /**
     * 是否为本地前端开发环境
     * @returns {boolean}
     */
    static isLocalFrontend() {
        const hostname = window.location.hostname;
        return hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname === '0.0.0.0';
    }

    /**
     * 获取 WebSocket 服务器地址
     * @returns {string} WebSocket 服务器地址
     */
    static getServerUrl() {
        const protocol = USE_SSL ? 'wss' : 'ws';
        return `${protocol}://${REMOTE_HOST}:${WS_PORT}`;
    }

    /**
     * 获取 HTTP API 服务器地址（用于登录/注册）
     * @returns {string} HTTP API 服务器地址
     */
    static getApiBaseUrl() {
        const protocol = USE_SSL ? 'https' : 'http';
        return `${protocol}://${REMOTE_HOST}:${HTTP_PORT}`;
    }

    /**
     * 获取默认服务器地址（用于显示）
     * @returns {string} 默认服务器地址
     */
    static getDefaultServerUrl() {
        return this.getServerUrl();
    }
}
